import { useState } from "react";
import { Linking, Pressable, StyleSheet, View } from "react-native";

import { useTranslation } from "@luna-restaurant/i18n";
import { ThemedText, useCustomTheme } from "@luna-restaurant/ui";

export const ThemedFooter = () => {
  const { colors, fonts } = useCustomTheme();
  const { t } = useTranslation();
  const [hoveredLink, setHoveredLink] = useState<string | null>(null);

  const openExternalLink = (url: string) => {
    Linking.openURL(url);
  };

  return (
    <View style={[styles.footer, { backgroundColor: colors.successLighter }]}>
      <ThemedText style={[styles.text, { ...fonts.bold, color: colors.text }]}>
        {t("common.lunaGmbh")}
      </ThemedText>
      <View style={styles.links}>
        <Pressable
          onPress={() => openExternalLink("https://luna.de/kontakt/")}
          onHoverIn={() => setHoveredLink("kontakt")}
          onHoverOut={() => setHoveredLink(null)}
        >
          <ThemedText
            style={[
              styles.link,
              { ...fonts.semiBold, color: colors.text },
              hoveredLink === "kontakt" && styles.linkHovered,
            ]}
          >
            {t("common.contact")}
          </ThemedText>
        </Pressable>

        <Pressable
          onPress={() => openExternalLink("https://luna.de/faq-schulen/")}
          onHoverIn={() => setHoveredLink("faq")}
          onHoverOut={() => setHoveredLink(null)}
        >
          <ThemedText
            style={[
              styles.link,
              { ...fonts.semiBold, color: colors.text },
              hoveredLink === "faq" && styles.linkHovered,
            ]}
          >
            {t("common.faq")}
          </ThemedText>
        </Pressable>

        <Pressable
          onPress={() => openExternalLink("https://luna.de/impressum/")}
          onHoverIn={() => setHoveredLink("impressum")}
          onHoverOut={() => setHoveredLink(null)}
        >
          <ThemedText
            style={[
              styles.link,
              { ...fonts.semiBold, color: colors.text },
              hoveredLink === "impressum" && styles.linkHovered,
            ]}
          >
            {t("common.imprint")}
          </ThemedText>
        </Pressable>

        <Pressable
          onPress={() => openExternalLink("https://luna.de/datenschutz/")}
          onHoverIn={() => setHoveredLink("datenschutz")}
          onHoverOut={() => setHoveredLink(null)}
        >
          <ThemedText
            style={[
              styles.link,
              { ...fonts.semiBold, color: colors.text },
              hoveredLink === "datenschutz" && styles.linkHovered,
            ]}
          >
            {t("common.privacy")}
          </ThemedText>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 40,
    paddingVertical: 16,
    width: "100%",
    maxHeight: 56,
  },
  text: {
    fontSize: 15,
    lineHeight: 18,
  },
  links: {
    flexDirection: "row",
    gap: 32,
  },
  link: {
    fontSize: 12,
    lineHeight: 14.4,
    padding: 4,
    borderWidth: 2,
    borderColor: "transparent",
    borderRadius: 6,
  },
  linkHovered: {
    borderColor: "black",
  },
});
